import HeroContent from './sections/HeroContent';
import AuthCard from './sections/AuthCard/AuthCard';

const HeroSection = ({ defaultTab = 'login' }) => {
  return (
    <div className="relative w-full min-h-[100vh] flex flex-col md:flex-row overflow-hidden z-20 bg-main">
      {/* Gradient Filter Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-white via-white/95 to-[#067978]/5 z-0 w-full md:w-[70%] lg:w-[60%]" />

      {/* Left Hero Content Panel */}
      <HeroContent />

      {/* Right Form Container Panel */}
      <div className="w-full md:w-[45%] flex items-center justify-center p-3 sm:p-6 md:p-8 pt-6 sm:pt-10 md:pt-16 lg:pt-20 pb-8 sm:pb-10 relative z-10 bg-transparent my-auto">
        <AuthCard defaultTab={defaultTab} />
      </div>
    </div>
  );
};

export default HeroSection;
